import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import PropTypes from 'prop-types'
import { InputAdornment } from '@mui/material'
import DatePickerWrapper from '../../styles/react-datepicker'
import CustomTextField from '../mui/text-field'
import { BsCalendar4 } from 'react-icons/bs'

export default function CustomDatePicker({
  onChange,
  value,
  disabled = false,
  dateFormat = 'dd/MM/yyyy',
  isClearable,
  placeholder = '',
  ...other
}) {
  return (
    <DatePickerWrapper>
      <DatePicker
        {...other}
        placeholderText={placeholder}
        isClearable={isClearable}
        disabled={disabled}
        selected={value}
        dateFormat={dateFormat}
        onChange={onChange}
        customInput={
          <CustomTextField
            id="icons-adornment-date"
            type={'text'}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <BsCalendar4 size={18} />
                </InputAdornment>
              )
            }}
          />
        }
        autoComplete="off"
      />
    </DatePickerWrapper>
  )
}

CustomDatePicker.propTypes = {
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  dateFormat: PropTypes.string,
  disabled: PropTypes.bool
}
